






import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Icon extends Vue {
  @Prop({ required: true })
  public readonly icon!: string;

  @Prop({ default: '' })
  public readonly colour!: string;

  @Prop({ default: 'md' })
  public readonly pack!: string;

  @Prop()
  public readonly block!: boolean;

  get fileName(): string {
    const parts = [this.pack];

    if (this.colour) parts.push(this.colour);

    parts.push(`${this.icon}.svg`);

    return parts.join('/');
  }
}
